import Modal from './Modal';
import IntakeForm from '../Intake';

interface IntakeModalProps {
  isOpen: boolean;
  onClose: () => void;
  user?: { name?: string; email?: string };
}

const IntakeModal = ({ isOpen, onClose, user }: IntakeModalProps) => {
  const handleSuccess = () => {
    onClose();
  };

  return (
    <Modal show={isOpen} onClose={onClose} title="Create Your Race Plan">
      <IntakeForm onSuccess={handleSuccess} user={user} />
    </Modal>
  );
};

export default IntakeModal;
